function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/TOOLS/ico-30-line-fat");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/TOOLS/ico-30-line-thick",
  stroke: "#000000",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("line", {
  x1: 24.5,
  y1: 25,
  x2: 5,
  y2: 5.5,
  id: "Line"
})));

const SvgIco30Mur = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30Mur, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-mur.27b21ca2.svg";
export { ForwardRef as ReactComponent };